/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7.25 11.5C7.6625 11.5 8 11.8375 8 12.25C8 12.6625 7.6625 13 7.25 13M7.25 11.5C6.8375 11.5 6.5 11.8375 6.5 12.25C6.5 12.6625 6.8375 13 7.25 13M7.25 11.5V13M11.75 11.5C12.1625 11.5 12.5 11.8375 12.5 12.25C12.5 12.6625 12.1625 13 11.75 13M11.75 11.5C11.3375 11.5 11 11.8375 11 12.25C11 12.6625 11.3375 13 11.75 13M11.75 11.5V13M16.75 11.5C17.1625 11.5 17.5 11.8375 17.5 12.25C17.5 12.6625 17.1625 13 16.75 13M16.75 11.5C16.3375 11.5 16 11.8375 16 12.25C16 12.6625 16.3375 13 16.75 13M16.75 11.5V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				fill="currentColor"
			/>
			<path
				d="M7.25 11.5C7.6625 11.5 8 11.8375 8 12.25C8 12.6625 7.6625 13 7.25 13M7.25 11.5C6.8375 11.5 6.5 11.8375 6.5 12.25C6.5 12.6625 6.8375 13 7.25 13M7.25 11.5V13M11.75 11.5C12.1625 11.5 12.5 11.8375 12.5 12.25C12.5 12.6625 12.1625 13 11.75 13M11.75 11.5C11.3375 11.5 11 11.8375 11 12.25C11 12.6625 11.3375 13 11.75 13M11.75 11.5V13M16.75 11.5C17.1625 11.5 17.5 11.8375 17.5 12.25C17.5 12.6625 17.1625 13 16.75 13M16.75 11.5C16.3375 11.5 16 11.8375 16 12.25C16 12.6625 16.3375 13 16.75 13M16.75 11.5V13M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.52606 1.90396C5.80953 1.25 7.48969 1.25 10.85 1.25H13.15C16.5103 1.25 18.1905 1.25 19.4739 1.90396C20.6029 2.4792 21.5208 3.39709 22.096 4.52606C22.75 5.80953 22.75 7.48969 22.75 10.85V13.15C22.75 16.5103 22.75 18.1905 22.096 19.4739C21.5208 20.6029 20.6029 21.5208 19.4739 22.096C18.1905 22.75 16.5103 22.75 13.15 22.75H10.85C7.48969 22.75 5.80953 22.75 4.52606 22.096C3.39708 21.5208 2.4792 20.6029 1.90396 19.4739C1.25 18.1905 1.25 16.5103 1.25 13.15V10.85C1.25 7.48969 1.25 5.80953 1.90396 4.52606C2.4792 3.39708 3.39709 2.4792 4.52606 1.90396ZM5.75 12.25C5.75 13.0767 6.42329 13.75 7.25 13.75C8.07671 13.75 8.75 13.0767 8.75 12.25C8.75 11.4233 8.07671 10.75 7.25 10.75C6.42329 10.75 5.75 11.4233 5.75 12.25ZM10.25 12.25C10.25 13.0767 10.9233 13.75 11.75 13.75C12.5767 13.75 13.25 13.0767 13.25 12.25C13.25 11.4233 12.5767 10.75 11.75 10.75C10.9233 10.75 10.25 11.4233 10.25 12.25ZM15.25 12.25C15.25 13.0767 15.9233 13.75 16.75 13.75C17.5767 13.75 18.25 13.0767 18.25 12.25C18.25 11.4233 17.5767 10.75 16.75 10.75C15.9233 10.75 15.25 11.4233 15.25 12.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C8.07116 2 7.60674 2 7.21684 2.05133C4.52444 2.40579 2.40579 4.52444 2.05133 7.21684C2 7.60674 2 8.07116 2 9L2 12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14709 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V9C22 8.07116 22 7.60674 21.9487 7.21684C21.5942 4.52444 19.4756 2.40579 16.7832 2.05133C16.3933 2 15.9288 2 15 2V2L14.5 2M7.25 11.5C7.6625 11.5 8 11.8375 8 12.25C8 12.6625 7.6625 13 7.25 13M7.25 11.5C6.8375 11.5 6.5 11.8375 6.5 12.25C6.5 12.6625 6.8375 13 7.25 13M7.25 11.5V13M11.75 11.5C12.1625 11.5 12.5 11.8375 12.5 12.25C12.5 12.6625 12.1625 13 11.75 13M11.75 11.5C11.3375 11.5 11 11.8375 11 12.25C11 12.6625 11.3375 13 11.75 13M11.75 11.5V13M16.75 11.5C17.1625 11.5 17.5 11.8375 17.5 12.25C17.5 12.6625 17.1625 13 16.75 13M16.75 11.5C16.3375 11.5 16 11.8375 16 12.25C16 12.6625 16.3375 13 16.75 13M16.75 11.5V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7.25 11.5C7.6625 11.5 8 11.8375 8 12.25C8 12.6625 7.6625 13 7.25 13M7.25 11.5C6.8375 11.5 6.5 11.8375 6.5 12.25C6.5 12.6625 6.8375 13 7.25 13M7.25 11.5V13M11.75 11.5C12.1625 11.5 12.5 11.8375 12.5 12.25C12.5 12.6625 12.1625 13 11.75 13M11.75 11.5C11.3375 11.5 11 11.8375 11 12.25C11 12.6625 11.3375 13 11.75 13M11.75 11.5V13M16.75 11.5C17.1625 11.5 17.5 11.8375 17.5 12.25C17.5 12.6625 17.1625 13 16.75 13M16.75 11.5C16.3375 11.5 16 11.8375 16 12.25C16 12.6625 16.3375 13 16.75 13M16.75 11.5V13M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.85 1.25C7.48969 1.25 5.80953 1.25 4.52606 1.90396C3.39709 2.4792 2.4792 3.39708 1.90396 4.52606C1.25 5.80953 1.25 7.48969 1.25 10.85L1.25 13.15C1.25 16.5103 1.25 18.1905 1.90396 19.4739C2.4792 20.6029 3.39708 21.5208 4.52606 22.096C5.80953 22.75 7.48969 22.75 10.85 22.75H13.15C16.5103 22.75 18.1905 22.75 19.4739 22.096C20.6029 21.5208 21.5208 20.6029 22.096 19.4739C22.75 18.1905 22.75 16.5103 22.75 13.15V10.85C22.75 7.48969 22.75 5.80953 22.096 4.52606C21.5208 3.39709 20.6029 2.4792 19.4739 1.90396C18.1905 1.25 16.5103 1.25 13.15 1.25L10.85 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.25 13.75C6.42329 13.75 5.75 13.0767 5.75 12.25C5.75 11.4233 6.42329 10.75 7.25 10.75C8.07671 10.75 8.75 11.4233 8.75 12.25C8.75 13.0767 8.07671 13.75 7.25 13.75ZM11.75 13.75C10.9233 13.75 10.25 13.0767 10.25 12.25C10.25 11.4233 10.9233 10.75 11.75 10.75C12.5767 10.75 13.25 11.4233 13.25 12.25C13.25 13.0767 12.5767 13.75 11.75 13.75ZM16.75 13.75C15.9233 13.75 15.25 13.0767 15.25 12.25C15.25 11.4233 15.9233 10.75 16.75 10.75C17.5767 10.75 18.25 11.4233 18.25 12.25C18.25 13.0767 17.5767 13.75 16.75 13.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
